/** spec 2.8 / 5d.2: 分享前宠物名默认随机从预置名单 */
export const PET_NAMES = [
  '团子', '豆豆', 'Lucky', '小白', '毛球', '可乐', '奶茶', '旺财', '来福', '包子', '糯米', '布丁',
];

/** MVP mock result (spec: 2.2/2.3/2.4 可用模拟/占位) */
export const MOCK_RESULT = {
  breed: '金毛寻回犬',
  breedMeta: '相似度 98%',
  emotion: '超开心',
  emotionMeta: '尾巴摇得很欢～',
  health: '体型刚好',
  healthMeta: '保持现在的运动量就很好',
};

export const DAILY_QUOTA = 5;
export const STORAGE_UID_KEY = 'pawai_uid';
export const STORAGE_PET_NAME_KEY = 'pawai_petName';
export const STORAGE_PET_AGE_KEY = 'pawai_petAge';
